"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { PostsProvider, usePosts } from "@/integrations/wordpress/WordPressPostsProvider";
import { WP_Query } from "@/integrations/wordpress/wp_query";
import { Card } from "@/components/ui/card";
import { PenTool, Monitor, Share2, ChartBar, Search, Target, ShoppingCart, Settings, Camera, ShieldCheck, CalendarDays, Mail, Zap } from "lucide-react";
const getIconForService = (title: string) => {
  const normalizedTitle = title.toLowerCase();
  if (normalizedTitle.includes("branding")) return PenTool;
  if (normalizedTitle.includes("website") || normalizedTitle.includes("web")) return Monitor;
  if (normalizedTitle.includes("redes sociais") || normalizedTitle.includes("social")) return Share2;
  if (normalizedTitle.includes("dados") || normalizedTitle.includes("data")) return ChartBar;
  if (normalizedTitle.includes("google")) return Search;
  if (normalizedTitle.includes("ads") || normalizedTitle.includes("publicidade")) return Target;
  if (normalizedTitle.includes("marketplace")) return ShoppingCart;
  if (normalizedTitle.includes("software") || normalizedTitle.includes("sistema")) return Settings;
  if (normalizedTitle.includes("foto") || normalizedTitle.includes("vídeo") || normalizedTitle.includes("video")) return Camera;
  if (normalizedTitle.includes("cibersegurança") || normalizedTitle.includes("segurança")) return ShieldCheck;
  if (normalizedTitle.includes("feira") || normalizedTitle.includes("evento")) return CalendarDays;
  if (normalizedTitle.includes("email") || normalizedTitle.includes("e-mail")) return Mail;
  return Zap;
};
function ServicesGridConsumer() {
  const {
    posts,
    loading,
    error
  } = usePosts();
  if (loading) {
    return <div data-section-id="225894" className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-4">
        {[...Array(8)].map((_, i) => <div key={i} data-index={i} className="h-[280px] rounded-xl bg-muted/50 animate-pulse border border-border" />)}
      </div>;
  }
  if (error) {
    return <div className="text-center py-12 text-muted-foreground">
        <p>Nem sikerült betölteni a járatinformációkat.</p>
      </div>;
  }
  if (posts.length === 0) {
    return <div className="text-center py-12 text-muted-foreground">
        <p>Jelenleg nincsenek elérhető járatok.</p>
      </div>;
  }
  return <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-4">
      {posts.map((post, i) => {
      const title = post.customFields?.titulo || post.title;
      const description = post.customFields?.descricao || "Prémium utazási élmény modern flottánkkal és kényelmi szolgáltatásokkal.";
      const Icon = getIconForService(title);
      const labelNumber = (i + 1).toString().padStart(2, '0');
      return <Link key={post.id} to="#" data-index={i} className="group block h-full outline-none focus-visible:ring-2 focus-visible:ring-primary rounded-xl">
            <Card className="h-full bg-card/60 backdrop-blur-md border border-border/50 rounded-xl p-6 md:p-8 flex flex-col gap-6 transition-all duration-300 hover:bg-card hover:shadow-xl hover:-translate-y-1">
              <div className="flex justify-between items-start">
                <span className="text-xs font-mono text-muted-foreground tracking-widest uppercase">FLIGHT.{labelNumber}</span>
                <Icon className="w-8 h-8 text-primary stroke-[1.5] transition-transform duration-300 group-hover:scale-110" />
              </div>
              <div className="mt-auto pt-8">
                <h3 className="text-2xl font-bold text-foreground font-serif mb-3">{title}</h3>
                <p className="text-sm text-muted-foreground leading-relaxed line-clamp-3 font-default">{description}</p>
              </div>
            </Card>
          </Link>;
    })}
    </div>;
}
export default function PremiumServices() {
  const wp_query_params = {
    post_type: "service",
    per_page: 12,
    orderby: "title",
    order: "asc"
  };
  const wp_query = new WP_Query(wp_query_params);
  return <section id="flightinformation" className="bg-background text-foreground py-[120px]">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 mb-16 items-end">
          <div className="lg:col-span-5">
            <h2 className="text-5xl md:text-7xl font-serif text-secondary leading-tight mb-6">Fedezze fel a világot velünk</h2>
            <p className="text-xl text-muted-foreground font-default max-w-md">
              Személyre szabott repülőjegy foglalás és valós idejű járatinformációk a legmagasabb szintű kényelemért.
            </p>
          </div>
          <div className="lg:col-span-7 flex justify-end">
            <div className="bg-primary/5 border border-primary/10 px-6 py-3 rounded-full">
              <span className="text-sm font-mono text-primary font-semibold">AKTÍV JÁRATOK ÉS AJÁNLATOK</span>
            </div>
          </div>
        </div>
        <PostsProvider wp_query={{
        post_type: "service",
        per_page: 12,
        orderby: "title",
        order: "asc"
      }}>
          <ServicesGridConsumer />
        </PostsProvider>
      </div>
    </section>;
}